import enTranslations from '../locales/en.json';
import koTranslations from '../locales/ko.json';

export const supportedLanguages = [
  { code: 'en', label: 'English' },
  { code: 'ko', label: '한국어' },
];

export const resources = {
  en: { translation: enTranslations },
  ko: { translation: koTranslations },
};

export const defaultLanguage = 'en';

